module.exports = __webpack_public_path__ + "img/dad-logo.dc94ea04.png";